import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  static values = { 
    url: String,
    id: String,
    action: String,
    controller: String
  }

  connect() {
    // Add click event listener to the element
    this.element.addEventListener("click", this.handleClick.bind(this))
    // Add cursor pointer to indicate clickable
    this.element.style.cursor = "pointer"
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick.bind(this))
  }

  handleClick(event) {
    event.preventDefault()
    
    let redirectUrl = this.buildUrl()
    
    if (redirectUrl) {
      try {
        visit(redirectUrl)
      } catch(_) {
        window.location.href = redirectUrl
      }
    }
  }

  buildUrl() {
    // Priority order: direct URL > constructed from controller/action/id
    if (this.hasUrlValue) {
      return this.urlValue
    }
    
    if (this.hasControllerValue && this.hasActionValue) {
      let url = `/${this.controllerValue}`
      
      if (this.hasIdValue) {
        url += `/${this.idValue}`
      }
      
      if (this.actionValue !== 'show') {
        url += `/${this.actionValue}`
      }
      
      return url
    }
    
    console.error("Redirect controller: No valid URL or controller/action provided")
    return null
  }
}